import { render, staticRenderFns } from "./PcbMasterMaintain.vue?vue&type=template&id=c855e506&scoped=true"
import script from "./PcbMasterMaintain.vue?vue&type=script&lang=js"
export * from "./PcbMasterMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c855e506",
  null
  
)

export default component.exports